import { Box, Button, Grid, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";

const StartEarning = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        background: "linear-gradient(135deg, #f0f4f8 0%, #e0f7fa 100%)",
        py: { xs: 6, md: 10 },
        px: { xs: 3, md: 12 },
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Image */}
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src="https://amentotech.com/projects/workreap/wp-content/uploads/2021/03/icon-01-1.png"
            alt="Earning Illustration"
            sx={{
              width: "100%",
              maxHeight: "300px",
              objectFit: "contain",
              display: { xs: "none", md: "block" },
            }}
          />
        </Grid>

        {/* Content */}
        <Grid item xs={12} md={4}>
          <Stack spacing={3} textAlign="center">
            <Typography variant="h4" fontWeight="bold" color="primary">
              Start Your Journey with Ghorami
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Build valuable connections with expert freelancers or clients
              around the world through Ghorami. Whether you're offering a
              service or seeking talent – we've got you covered.
            </Typography>
            <Stack direction="row" spacing={2} justifyContent="center">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#111",
                  color: "#fff",
                  px: 4,
                  py: 1.5,
                  borderRadius: "30px",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#333",
                  },
                }}
                onClick={() => window.open("http://user.songjukti.com/")}
              >
                I Want to Service
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#009C8B",
                  color: "#fff",
                  px: 4,
                  py: 1.5,
                  borderRadius: "30px",
                  fontWeight: 600,
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#007e6d",
                  },
                }}
                onClick={() => window.open("http://user.songjukti.com/")}
              >
                I Want to Work
              </Button>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              By continuing, you agree to our{" "}
              <Box
                component="span"
                sx={{ color: "#59b8d7", cursor: "pointer" }}
                onClick={() => window.open("https://songjukti.com/terms")}
              >
                Terms
              </Box>{" "}
              and{" "}
              <Box
                component="span"
                sx={{ color: "#59b8d7", cursor: "pointer" }}
                onClick={() =>
                  window.open("https://songjukti.com/privacypolicy")
                }
              >
                Privacy Policy
              </Box>
              .
            </Typography>
          </Stack>
        </Grid>

        {/* Right Image */}
        <Grid item xs={12} md={4}>
          <Box
            component="img"
            src="https://amentotech.com/projects/workreap/wp-content/uploads/2021/03/img-02-1.png"
            alt="Work Illustration"
            sx={{
              width: "100%",
              maxHeight: "300px",
              objectFit: "contain",
              display: { xs: "none", md: "block" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default StartEarning;
